// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

export const ORDER_STATUS_EVENTS = {
    'ordersubmitted': 'ordersubmitted',
    'nt_released': 'nt_released',
    'ctn': 'ctn',
    'ctn_create': 'ctn_create',
    'rd_received': 'rd_received',
    'disposition_detail': 'disposition_detail',
    'disposition_final': 'disposition_final',
    'od_pgi': 'od_pgi',
    'nt_cancel': 'nt_cancel',
    'nt_autocomplete': 'nt_autocomplete',
    'orderreject': 'orderreject',
    'nt_completed': 'nt_completed',
    'delivery_cd': 'delivery_cd',
    'pickup': 'pickup',
    'nt_autocancel': 'nt_autocancel',
    'order_autocancel': 'order_autocancel',
    'order_autocomplete': 'order_autocomplete',
    'cancelsubmit': 'cancelsubmit',
    'warning_first': 'warning_first',
    'warning_second': 'warning_second',
    'warning_charged': 'warning_charged',
    'paymentcomplete': 'paymentcomplete',
    'paymentpending': 'paymentpending',
    'refundreject': 'refundreject',
    'refundinitiate': 'refundinitiate',
    'refundcomplete': 'refundcomplete',
    'failedpolicy_return': 'failedpolicy_return',
    'failedpolicy_device': 'failedpolicy_device',
    'failedpolicy_delivery': 'failedpolicy_delivery',
    'od_pgi_box': 'empty_box_for_return_shipped_to_customer',
    'shipmentdelaynotification': 'shipmentdelaynotification',
    'nt_confirmed': 'nt_confirmed',
    'onsite_partner_travelled': 'onsite_partner_travelled',
};

export function orderEventStateLookUp(event: string | undefined): string {
    if (!event) {
        return '';
    }

    const value = ORDER_STATUS_EVENTS[event];

    if (!value) {
        throw Error(`Order status event not found. event: ${event}`);
    }

    return value;
}